export enum VerticalBreakpoints {
	/**
	 * Viewport height threshold, used for narrow viewports in landscape mode.
	 * Height in pixel, determined by experiment.
	 * iPhone 14 Pro Max has 430 width
	 */
	b340 = 440
}

export const landscapeMediaMixin = `(max-height: ${VerticalBreakpoints.b340}px) and (orientation: landscape)`;
